export const componentTitleDefaults = () => ({
  text: '设备在线情况', fontSize: 16, fontFamily: 'Microsoft YaHei', fontWeight: 600,
  color: '#d8f4ff', backgroundColor: 'transparent', showMarker: true,
  markerColor: '#19cfff', markerWidth: 3, markerGap: 8
})
export const COMPONENT_TITLE_OPTION_KEYS = Object.freeze(Object.keys(componentTitleDefaults()))

export function createComponentTitle () {
  return { label: '组件标题', cover: 'ui/component-title.svg', option: {
    name: '组件标题', title: '组件标题', icon: 'icon-text', dataType: 0, data: {}, time: 0, top: 0, left: 0,
    component: { width: 240, height: 32, name: 'componentTitle', prop: 'componentTitle' }, option: componentTitleDefaults()
  } }
}

const number = (value, fallback, min, max) => ['number', 'string'].includes(typeof value) && String(value).trim() !== '' && Number.isFinite(Number(value))
  ? Math.max(min, Math.min(max, Number(value))) : fallback
const color = (value, fallback) => typeof value === 'string' && /^(?:#(?:[a-f\d]{3}|[a-f\d]{4}|[a-f\d]{6}|[a-f\d]{8})|(?:rgb|hsl)a?\([\d\s.,%+/-]+\)|transparent|white|black)$/i.test(value) ? value : fallback

// 沿用设备在线情况自带小标题的比例：3px短竖线、8px间距、16px半粗文字。
export function componentTitleSettings (input = {}) {
  const defaults = componentTitleDefaults(), option = { ...defaults, ...input }
  return {
    text: typeof option.text === 'string' ? option.text.slice(0, 200) : defaults.text,
    fontSize: number(option.fontSize, defaults.fontSize, 10, 100),
    fontFamily: typeof option.fontFamily === 'string' && /^[\w\s\u4e00-\u9fa5,'"-]{1,120}$/.test(option.fontFamily) ? option.fontFamily : defaults.fontFamily,
    fontWeight: /^(?:normal|bold|bolder|lighter|[1-9]00)$/.test(String(option.fontWeight)) ? option.fontWeight : defaults.fontWeight,
    color: color(option.color, defaults.color), backgroundColor: color(option.backgroundColor, defaults.backgroundColor),
    showMarker: typeof option.showMarker === 'boolean' ? option.showMarker : defaults.showMarker,
    markerColor: color(option.markerColor, defaults.markerColor),
    markerWidth: number(option.markerWidth, defaults.markerWidth, 1, 10),
    markerGap: number(option.markerGap, defaults.markerGap, 0, 32)
  }
}

export function componentTitleStyle (input = {}) {
  const option = componentTitleSettings(input)
  return { '--component-title-marker': option.markerColor, '--component-title-marker-width': option.markerWidth + 'px',
    '--component-title-marker-gap': option.markerGap + 'px', color: option.color, backgroundColor: option.backgroundColor,
    fontSize: option.fontSize + 'px', fontFamily: option.fontFamily, fontWeight: option.fontWeight }
}
